export const Store = {
    data: {
        user: {},
        documentSets: {},
        currentDocumentSet: {}
    },
    destroy: function () {
        this.data.user = {};
        this.data.documentSets = {};
        this.data.currentDocumentSet = {};
    }
};



// WEBPACK FOOTER //
// ./src/store.js